import { Component, inject, output, signal } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';
import { AuthService } from '../../auth';
import { LogoutDialogComponent } from './logout-dialog/logout-dialog.component';
import { OrdersService } from '../orders/orders.service';

@Component({
  selector: 'app-side-menu',
  imports: [RouterLink, RouterLinkActive, LogoutDialogComponent],
  templateUrl: './side-menu.html',
  styleUrl: './side-menu.css'
})
export class SideMenu {
  readonly closeMenu = output<void>();
  protected readonly showLogoutConfirm = signal(false);

  readonly #authService = inject(AuthService);
  readonly #ordersService = inject(OrdersService);

  protected readonly waitingForApprovalCount = toSignal(
    this.#ordersService.getOrders().pipe(
      map(orders => orders.filter(o => o.status === 'waitingForApproval').length)
    ),
    { initialValue: 0 }
  );

  protected onMenuItemClick() {
    this.closeMenu.emit();
  }

  protected onLogout() {
    this.showLogoutConfirm.set(true);
  }

  protected confirmLogout() {
    this.showLogoutConfirm.set(false);
    this.closeMenu.emit();
    void this.#authService.signOut();
  }
}
